export var SERVICE_IDENTIFIER;
(function (SERVICE_IDENTIFIER) {
    SERVICE_IDENTIFIER["CONFIGURATOR_SERVICE"] = "CONFIGURATOR_SERVICE";
    SERVICE_IDENTIFIER["MICROPHONE_SERVICE"] = "MICROPHONE_SERVICE";
    SERVICE_IDENTIFIER["BARS_SERVICE"] = "BARS_SERVICE";
})(SERVICE_IDENTIFIER || (SERVICE_IDENTIFIER = {}));
